/**
 * @author NikolaV
 */

import * as React from 'react';
import { Button } from "@shared/ui-react/Button";
import { MapToolsStore } from "@openlayers/MapToolsStore";
import { cs } from "@shared/utils/utils-classname";
import { observer } from "mobx-react";
import { Dropdown } from '@shared/ui-react/Dropdown'

@observer
export class MapToolsButtons extends React.Component<{
    toolsStore: MapToolsStore,
    showClearMeasurementsLabel?: boolean,
    openCrossSectionWindow: Function,
    openLongSectionWindow: Function,
    showInteractionsSubmenu: boolean
}> {
    static defaultProps = {
        showInteractionsSubmenu: true
    }

    render() {
        const store = this.props.toolsStore;

        return <>
            <div className="btn-group">
                <Button secondary icon='iki iki-cursor' onClick={store.deactivateAllTools}
                    className={cs({ active: !store.activeTool })} />
                <Button secondary icon='iki iki-measure' onClick={store.activateDistanceTool} title={__('js_map_measuring_tools.distance') + '\n' + __('js_map_measuring_tools.modifiers_description')}
                    className={cs({ active: store.activeTool === store.distanceTool })} />
                <Button
                    secondary
                    onClick={store.activateAreaTool}
                    title={`${__('js_map_measuring_tools.area')}\n${__('js_map_measuring_tools.modifiers_description')}`}
                    className={cs({ active: store.activeTool === store.areaTool })}
                >
                    <span>
                        <i className='iki iki-area'></i>
                        <sup>2</sup>
                    </span>
                </Button>
                <Dropdown
                    className={`${cs({ active: store.activeTool === store.volumeTool })} ik-button-secondary`}
                    closeOnBodyClick={true}
                    title={__('js_map_measuring_tools.dem_volume_tool')}>
                    <span className="toolbar-optional-label"><span></span>
                        <i className='iki iki-area'></i>
                        <sup>3</sup>
                    </span>
                    <ul className="dropdown-list clickable">
                        <li onClick={store.activateStockpileVolumeTool} className={cs({ active: store.activeTool === store.volumeTool })}>{__('js_map_measuring_tools.stockpile_tool')}</li>
                        <li onClick={store.activateModelVolumeTool} className={cs({ active: store.activeTool === store.volumeTool })}>{__('js_map_measuring_tools.model_tool')}</li>
                    </ul>
                </Dropdown>
                {store.hasMeasurements &&
                    <Button secondary icon="iki iki-cross" id="map__clear-measurements" onClick={store.clearMeasurements}
                        style={{ order: this.props.showClearMeasurementsLabel ? 1 : 5 }}
                        title={__('js_map.tools.clear_measurements')}>{this.props.showClearMeasurementsLabel ? __('js_map.tools.clear_measurements') : null}</Button>
                }
            </div>

            <div className="btn-group">
                <Button secondary icon='iki iki-cross-section' onClick={this.props.openCrossSectionWindow} disabled={!store.hasMapAlignment} title={__('js_map_measuring_tools.draw_cross_section')} />
                <Button secondary icon='iki iki-draw-cross-section' onClick={store.activateFreeCsTool} title={__('js_map_measuring_tools.draw_free_cross_section')}
                    className={cs({ active: store.activeTool === store.freeCrossSectionTool })} />
                {typeof this.props.openLongSectionWindow === 'function' && <>
                    <Button secondary icon='iki iki-long-section' onClick={this.props.openLongSectionWindow} disabled={!store.hasMapAlignment} title={__('js_map_measuring_tools.draw_long_section')} />
                    <Button secondary icon='iki iki-draw-long-section' onClick={store.activateLongCsTool} disabled={!store.hasMapAlignment} title={__('js_map_measuring_tools.draw_free_long_section')}
                        className={cs({ active: store.activeTool === store.freeLongSectionTool })} />
                </>}
            </div>

            {this.props.showInteractionsSubmenu && store.activeTool === store.distanceTool || store.activeTool === store.areaTool || store.activeTool === store.volumeTool ?
                <div className="btn-group measure-tools-options" style={{ position: 'fixed', top: 120, right: '40vw', transform: 'translateX(50%)' }}>
                    <Button secondary onClick={store.toolInteractions.toggleModifyUserEnabled} style={{ order: 2 }} className={cs({ active: store.toolInteractions.modifyInteractionUserEnabled })}>{__('js_map_measuring_tools.modify')} [m]</Button>
                    <Button secondary onClick={store.toolInteractions.toggleSnapModelsUserEnabled} style={{ order: 2 }} className={cs({ active: store.toolInteractions.snapModelsInteractionUserEnabled })}>{__('js_map_measuring_tools.snap_to_models')} [s]</Button>
                    <Button secondary onClick={store.toolInteractions.toggleSnapGonsUserEnabled} onContextMenu={store.toolInteractions.setGons}
                        style={{ order: 2 }} className={cs({ active: store.toolInteractions.snapGonsInteractionUserEnabled })}>{__('js_map_measuring_tools.snap_to_n_gons', store.toolInteractions.gonsInterval)} [g]</Button>
                </div> : null
            }
        </>
    }
}
